import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "member-detail-page" }
const _hoisted_2 = { class: "tab-navigation" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "tab-hint"
}
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = { class: "ltc-info-title" }
const _hoisted_7 = {
  key: 0,
  class: "ltc-info-table"
}
const _hoisted_8 = { colspan: "3" }
const _hoisted_9 = { class: "biz-chips-display" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { colspan: "3" }
const _hoisted_12 = {
  key: 1,
  class: "ltc-info-table edit-mode"
}
const _hoisted_13 = { colspan: "3" }
const _hoisted_14 = { class: "biz-gubun-checkboxes" }
const _hoisted_15 = ["value", "checked", "disabled", "onChange"]
const _hoisted_16 = { class: "number-input-wrap" }
const _hoisted_17 = { class: "number-input-wrap" }
const _hoisted_18 = { colspan: "3" }
const _hoisted_19 = {
  colspan: "4",
  class: "edit-actions-cell"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_22 = { class: "ltc-info-table" }
const _hoisted_23 = { class: "id-edit-row" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "id-check-hint success"
}
const _hoisted_26 = {
  key: 1,
  class: "id-check-hint error"
}
const _hoisted_27 = {
  key: 2,
  class: "id-check-hint warning"
}
const _hoisted_28 = {
  key: 1,
  class: "password-display"
}
const _hoisted_29 = { class: "password-value" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  colspan: "4",
  class: "edit-actions-cell"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_35 = {
  key: 2,
  class: "ltc-info-table"
}
const _hoisted_36 = {
  key: 3,
  class: "ltc-info-table edit-mode"
}
const _hoisted_37 = {
  colspan: "4",
  class: "edit-actions-cell"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_40 = { class: "ltc-info-table" }
const _hoisted_41 = { colspan: "3" }
const _hoisted_42 = { colspan: "3" }
const _hoisted_43 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_44 = { class: "ltc-info-table" }
const _hoisted_45 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_46 = { class: "cert-section" }
const _hoisted_47 = {
  key: 0,
  class: "cert-loading"
}
const _hoisted_48 = {
  key: 1,
  class: "cert-registered"
}
const _hoisted_49 = { class: "ltc-info-table" }
const _hoisted_50 = {
  key: 0,
  class: "expire-warning"
}
const _hoisted_51 = {
  key: 1,
  class: "expire-warning"
}
const _hoisted_52 = {
  key: 0,
  class: "ip-management-section"
}
const _hoisted_53 = { class: "ip-count" }
const _hoisted_54 = {
  key: 0,
  class: "ip-management-content"
}
const _hoisted_55 = { class: "ip-header" }
const _hoisted_56 = { class: "my-ip-info" }
const _hoisted_57 = { class: "my-ip-value" }
const _hoisted_58 = {
  key: 0,
  class: "ip-loading"
}
const _hoisted_59 = {
  key: 1,
  class: "ip-empty"
}
const _hoisted_60 = {
  key: 2,
  class: "ip-list"
}
const _hoisted_61 = { class: "ip-info" }
const _hoisted_62 = { class: "ip-address" }
const _hoisted_63 = {
  key: 0,
  class: "ip-desc"
}
const _hoisted_64 = { class: "ip-actions" }
const _hoisted_65 = {
  key: 2,
  class: "cert-not-registered"
}
const _hoisted_66 = { class: "cert-empty-icon" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "ip-input-row" }
const _hoisted_69 = { class: "cert-upload-modal" }
const _hoisted_70 = { class: "modal-header modal-header--dark" }
const _hoisted_71 = { class: "modal-body" }
const _hoisted_72 = {
  key: 0,
  class: "cert-mode-tabs"
}
const _hoisted_73 = {
  key: 1,
  class: "password-only-mode"
}
const _hoisted_74 = { class: "current-cert-info" }
const _hoisted_75 = { class: "info-value" }
const _hoisted_76 = { class: "info-sub" }
const _hoisted_77 = { class: "upload-field" }
const _hoisted_78 = { class: "password-input-wrap" }
const _hoisted_79 = ["type"]
const _hoisted_80 = { class: "password-hint" }
const _hoisted_81 = { class: "cert-guide npki-guide" }
const _hoisted_82 = { class: "guide-header" }
const _hoisted_83 = { class: "guide-steps" }
const _hoisted_84 = { class: "guide-step" }
const _hoisted_85 = { class: "step-content" }
const _hoisted_86 = { class: "path-box" }
const _hoisted_87 = { class: "upload-field" }
const _hoisted_88 = { class: "cert-pick-actions" }
const _hoisted_89 = {
  key: 0,
  class: "drop-zone-content"
}
const _hoisted_90 = {
  key: 1,
  class: "drop-zone-files"
}
const _hoisted_91 = { class: "file-status" }
const _hoisted_92 = { class: "file-status" }
const _hoisted_93 = {
  key: 0,
  class: "change-hint"
}
const _hoisted_94 = { class: "upload-field" }
const _hoisted_95 = { class: "password-input-wrap" }
const _hoisted_96 = ["type"]
const _hoisted_97 = ["title"]
const _hoisted_98 = { class: "password-hint" }
const _hoisted_99 = {
  key: 0,
  class: "cert-info-box"
}
const _hoisted_100 = { class: "cert-info-header" }
const _hoisted_101 = { class: "cert-info-row" }
const _hoisted_102 = { class: "cert-info-value" }
const _hoisted_103 = { class: "cert-info-row" }
const _hoisted_104 = { class: "cert-info-value" }
const _hoisted_105 = { class: "cert-notice" }
const _hoisted_106 = { class: "modal-footer" }
const _hoisted_107 = ["disabled"]
const _hoisted_108 = ["disabled"]
const _hoisted_109 = ["disabled"]
const _hoisted_110 = ["disabled"]
const _hoisted_111 = { class: "delete-confirm-dialog" }
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "dialog-icon" }
const _hoisted_114 = { class: "dialog-actions" }
const _hoisted_115 = ["disabled"]

import { ref, inject, onMounted, watch, computed } from 'vue';
import { usePageTabNav } from '@/composables/usePageTabNav';
import YmdDateInput from '@/components/common/YmdDateInput.vue';
import { useStore } from 'vuex';
import { crawlApi, memberApi, authApi, certApi } from '@/services/api';
import CrawlDetailContent from '@/pages/facility/CrawlDetailPopup.vue';
import HopeCertSection from '@/pages/member/detail/HopeCertSection.vue';
import forge from 'node-forge';
import { pickNpkiCertFiles, NPKI_PATH_HINT } from '@/utils/pickNpkiCertFiles';

interface BizGubunOption {
  bg_name: string;
  bg_color: string;
  bg_exclusive_group: string | null;
}

// 레이아웃에서 제공하는 데이터

export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDetailInfo',
  setup(__props) {

const store = useStore();
const roleLevel = computed(() => Number(store.getters.roleLevel || 0));
const isAdmin = computed(() => roleLevel.value >= 60);
const isSuperAdmin = computed(() => roleLevel.value >= 100);

// 사업구분 타입 정의
const memberData = inject<any>('memberData');
const bizGubunColorMap = inject<any>('bizGubunColorMap');

// 탭 상태
const mainTab = ref('member');

watch(isAdmin, (admin) => {
  if (!admin && mainTab.value === 'crawl') {
    mainTab.value = 'member';
  }
}, { immediate: true });

// 크롤링 데이터 연결 여부 확인용
const hasCrawlData = ref(false);

const infoPageTabs = computed(() => {
  const tabs: { key: string; title: string; disabled?: boolean }[] = [
    { key: 'member', title: '관리정보' },
  ];
  if (isAdmin.value) {
    tabs.push({
      key: 'crawl',
      title: '시설정보',
      disabled: !memberData?.value?.m_longterm_code || !hasCrawlData.value,
    });
  }
  return tabs;
});
usePageTabNav('facility-info', infoPageTabs, mainTab, (key) => {
  mainTab.value = key;
});

// 비밀번호 표시 상태
const showPassword = ref(false);

// 사업구분 옵션 목록
const bizGubunOptions = ref<BizGubunOption[]>([]);

// 기본정보 수정 상태
const isEditingBasicInfo = ref(false);
const savingBasicInfo = ref(false);
const basicInfoForm = ref({
  m_name: '',
  m_longterm_code: '',
  m_biz_gubun_list: [] as string[],
  m_biz_num: '',
  m_since: '',
  m_hyunwon: 0,
  m_jungwon: 0,
  m_addr: '',
  m_tell: '',
  m_boss_email: ''
});

// 로그인 정보 수정 상태
const isEditingCredentials = ref(false);
const savingCredentials = ref(false);
const idCheckLoading = ref(false);
const originalId = ref(''); // 원래 ID (변경 여부 확인용)
const credentialsForm = ref({
  m_id: '',
  m_pw: ''
});
const idCheckState = ref({
  checked: false,
  available: false
});

// 대표자 정보 수정 상태
const isEditingBossInfo = ref(false);
const savingBossInfo = ref(false);
const bossInfoForm = ref({
  m_boss_name: '',
  m_boss_phone: ''
});

// ID가 변경되었는지 확인
const isIdChanged = computed(() => {
  return credentialsForm.value.m_id.trim() !== originalId.value;
});

// 스낵바
const snackbar = ref(false);
const snackbarText = ref('');
const snackbarColor = ref('success');

// 인증서 관련 상태 (NPKI 원본 파일 방식)
const certLoading = ref(false);
const certInfo = ref<any>(null);
const showCertUploadModal = ref(false);
const showDeleteCertDialog = ref(false);
const certUploading = ref(false);
const certDeleting = ref(false);
const certPassword = ref('');
const showCertPassword = ref(false);
const certEditMode = ref<'password' | 'full'>('password');  // 비밀번호만 변경 / 전체 변경
const newCertPassword = ref('');
const showNewCertPassword = ref(false);
const certPasswordUpdating = ref(false);

// NPKI 파일 (signCert.der + signPri.key)
const signCertFile = ref<File | null>(null);
const signPriFile = ref<File | null>(null);
const signCertFileName = ref('');
const signPriFileName = ref('');
const certFilesInputRef = ref<HTMLInputElement | null>(null);
const certFolderInputRef = ref<HTMLInputElement | null>(null);
const pickedCertFolderHint = ref('');
const extractedCertInfo = ref<{ subject: string; expireDate: string } | null>(null);
const isDragOver = ref(false);

// IP 관리 상태 (슈퍼바이저 전용)
const showIpManagement = ref(false);
const allowedIPs = ref<any[]>([]);
const loadingIPs = ref(false);
const showAddIpDialog = ref(false);
const addingIP = ref(false);
const newIP = ref({ ip: '', description: '' });
const myIP = ref('');

// NPKI 경로 복사 (환경변수 사용 - 탐색기에서 자동 변환됨)
const copyNpkiPath = async () => {
  try {
    await navigator.clipboard.writeText(NPKI_PATH_HINT);
    snackbarText.value = '경로가 복사되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch {
    // Fallback for non-secure contexts
    const textarea = document.createElement('textarea');
    textarea.value = NPKI_PATH_HINT;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    snackbarText.value = '경로가 복사되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  }
};

const enableDirectoryPicker = (el: HTMLInputElement | null) => {
  if (!el) return;
  // Chromium/Edge(Windows NPKI): 폴더 선택
  (el as HTMLInputElement & { webkitdirectory?: boolean }).webkitdirectory = true;
  el.setAttribute('webkitdirectory', '');
  el.setAttribute('directory', '');
  el.multiple = true;
};

const triggerCertFolderInput = () => {
  enableDirectoryPicker(certFolderInputRef.value);
  certFolderInputRef.value?.click();
};

// 파일 2개 직접 선택
const triggerCertFilesInput = () => {
  certFilesInputRef.value?.click();
};

// 드래그 앤 드롭 이벤트 핸들러
const onDragOver = () => {
  isDragOver.value = true;
};

const onDragLeave = () => {
  isDragOver.value = false;
};

const onDrop = (event: DragEvent) => {
  isDragOver.value = false;
  const files = event.dataTransfer?.files;
  if (files && files.length > 0) {
    processFiles(files);
  }
};

// 인증서 업로드 가능 여부 (두 파일 + 비밀번호)
const canUploadCert = computed(() => {
  return signCertFile.value && signPriFile.value && certPassword.value.trim();
});

const certExpireDayDiff = (raw: unknown) => {
  if (!raw) return null;
  const expireDate = new Date(raw as string);
  if (Number.isNaN(expireDate.getTime())) return null;
  const expire = new Date(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate());
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((expire.getTime() - todayStart.getTime()) / (1000 * 60 * 60 * 24));
};

const isExpired = computed(() => {
  const diffDays = certExpireDayDiff(certInfo.value?.cic_expire_date);
  return diffDays !== null && diffDays < 0;
});

// 인증서 만료 임박 여부 (30일 이내, 아직 만료 전)
const isExpiringSoon = computed(() => {
  const diffDays = certExpireDayDiff(certInfo.value?.cic_expire_date);
  return diffDays !== null && diffDays <= 30 && diffDays >= 0;
});

// 마스킹된 비밀번호
const maskedPassword = computed(() => {
  const pw = memberData?.value?.m_pw;
  if (!pw) return '-';
  return '•'.repeat(pw.length);
});

// 사업구분 색상
const getBizGubunColor = (bizGubun: string) => {
  return bizGubunColorMap?.value?.[bizGubun] || '#607d8b';
};

// 사업구분 문자열을 배열로 파싱
const parseBizGubun = (bizGubunStr: string) => {
  if (!bizGubunStr) return [];
  return bizGubunStr.split(',').map(s => s.trim()).filter(Boolean);
};

// 현재 선택된 사업구분의 exclusive_group 조회
const getSelectedExclusiveGroup = (): string | null => {
  const selected = basicInfoForm.value.m_biz_gubun_list;
  if (selected.length === 0) return null;
  
  const firstSelected = selected[0];
  const biz = bizGubunOptions.value.find(b => b.bg_name === firstSelected);
  return biz?.bg_exclusive_group || null;
};

// 특정 그룹이 비활성화되어야 하는지 확인
const isBizGubunDisabled = (exclusiveGroup: string | null): boolean => {
  const currentGroup = getSelectedExclusiveGroup();
  if (!currentGroup) return false;
  if (!exclusiveGroup) return false;
  return currentGroup !== exclusiveGroup;
};

// 사업구분 토글
const toggleBizGubun = (bizName: string, exclusiveGroup: string | null) => {
  const current = basicInfoForm.value.m_biz_gubun_list;
  const idx = current.indexOf(bizName);
  
  if (idx >= 0) {
    current.splice(idx, 1);
  } else {
    const currentGroup = getSelectedExclusiveGroup();
    if (currentGroup && currentGroup !== exclusiveGroup) {
      return;
    }
    current.push(bizName);
  }
  
  // DB 순서대로 정렬
  const orderedBizList = bizGubunOptions.value.map(b => b.bg_name);
  current.sort((a, b) => orderedBizList.indexOf(a) - orderedBizList.indexOf(b));
};

// 사업구분 목록 로드
const loadBizGubunOptions = async () => {
  try {
    const response = await memberApi.getBizGubunList();
    if (response.data?.data) {
      bizGubunOptions.value = response.data.data;
    }
  } catch (error) {
    console.error('사업구분 목록 로드 오류:', error);
  }
};

// 기본정보 수정 시작
const startEditBasicInfo = () => {
  const data = memberData?.value;
  if (!data) return;
  
  basicInfoForm.value = {
    m_name: data.m_name || '',
    m_longterm_code: data.m_longterm_code || '',
    m_biz_gubun_list: parseBizGubun(data.m_biz_gubun),
    m_biz_num: data.m_biz_num || '',
    m_since: data.m_since ? formatDateForInput(data.m_since) : '',
    m_hyunwon: data.m_hyunwon || 0,
    m_jungwon: data.m_jungwon || 0,
    m_addr: data.m_addr || '',
    m_tell: data.m_tell || '',
    m_boss_email: data.m_boss_email || ''
  };
  isEditingBasicInfo.value = true;
};

// 기본정보 수정 취소
const cancelEditBasicInfo = () => {
  isEditingBasicInfo.value = false;
};

// 기본정보 저장
const saveBasicInfo = async () => {
  if (!memberData?.value?.m_code) return;
  
  // 유효성 검사
  if (!basicInfoForm.value.m_name.trim()) {
    snackbarText.value = '시설명을 입력해주세요.';
    snackbarColor.value = 'error';
    snackbar.value = true;
    return;
  }
  
  if (basicInfoForm.value.m_biz_gubun_list.length === 0) {
    snackbarText.value = '사업구분을 하나 이상 선택해주세요.';
    snackbarColor.value = 'error';
    snackbar.value = true;
    return;
  }
  
  savingBasicInfo.value = true;
  try {
    const updateData = {
      m_name: basicInfoForm.value.m_name.trim(),
      m_longterm_code: basicInfoForm.value.m_longterm_code.trim() || null,
      m_biz_gubun: basicInfoForm.value.m_biz_gubun_list.join(','),
      m_biz_num: basicInfoForm.value.m_biz_num.trim() || null,
      m_since: basicInfoForm.value.m_since || null,
      m_hyunwon: basicInfoForm.value.m_hyunwon || 0,
      m_jungwon: basicInfoForm.value.m_jungwon || 0,
      m_addr: basicInfoForm.value.m_addr.trim() || null,
      m_tell: basicInfoForm.value.m_tell.trim() || null,
      m_boss_email: basicInfoForm.value.m_boss_email.trim() || null
    };
    
    await memberApi.update(memberData.value.m_code, updateData);
    
    // 로컬 데이터 업데이트
    Object.assign(memberData.value, updateData);
    
    isEditingBasicInfo.value = false;
    snackbarText.value = '기본정보가 저장되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    console.error('기본정보 저장 오류:', error);
    snackbarText.value = error.response?.data?.message || '저장에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    savingBasicInfo.value = false;
  }
};

// 날짜를 input[type=date] 형식으로 변환
const formatDateForInput = (value: string | null | undefined) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// 포맷 유틸
const formatDate = (value: string | null | undefined) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const formatDateTime = (value: string | null | undefined) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

// 로그인 정보 수정 시작
const startEditCredentials = () => {
  credentialsForm.value.m_id = memberData?.value?.m_id || '';
  credentialsForm.value.m_pw = memberData?.value?.m_pw || '';
  originalId.value = memberData?.value?.m_id || '';
  idCheckState.value.checked = false;
  idCheckState.value.available = false;
  isEditingCredentials.value = true;
};

// ID 입력 변경 시 중복확인 상태 초기화
const onIdChange = () => {
  idCheckState.value.checked = false;
  idCheckState.value.available = false;
};

// ID 중복확인
const checkIdDuplicate = async () => {
  const memberId = credentialsForm.value.m_id.trim();
  if (!memberId) {
    alert('아이디를 입력해주세요.');
    return;
  }
  
  idCheckLoading.value = true;
  try {
    const response = await authApi.checkIdDuplicate(memberId, 'member');
    const isDuplicate = response.data?.data?.isDuplicate;
    
    idCheckState.value.checked = true;
    idCheckState.value.available = !isDuplicate;
  } catch (error: any) {
    console.error('ID 중복확인 오류:', error);
    alert('중복확인 중 오류가 발생했습니다.');
    idCheckState.value.checked = false;
    idCheckState.value.available = false;
  } finally {
    idCheckLoading.value = false;
  }
};

// 로그인 정보 수정 취소
const cancelEditCredentials = () => {
  isEditingCredentials.value = false;
  credentialsForm.value.m_id = '';
  credentialsForm.value.m_pw = '';
  originalId.value = '';
  idCheckState.value.checked = false;
  idCheckState.value.available = false;
};

// 로그인 정보 저장
const saveCredentials = async () => {
  if (!memberData?.value?.m_code) return;
  
  if (!credentialsForm.value.m_id.trim()) {
    snackbarText.value = '아이디를 입력해주세요.';
    snackbarColor.value = 'error';
    snackbar.value = true;
    return;
  }
  
  // ID가 변경되었으면 중복확인 필수
  if (isIdChanged.value && (!idCheckState.value.checked || !idCheckState.value.available)) {
    snackbarText.value = '아이디 중복확인을 해주세요.';
    snackbarColor.value = 'error';
    snackbar.value = true;
    return;
  }
  
  if (!credentialsForm.value.m_pw.trim()) {
    snackbarText.value = '비밀번호를 입력해주세요.';
    snackbarColor.value = 'error';
    snackbar.value = true;
    return;
  }
  
  savingCredentials.value = true;
  try {
    await memberApi.update(memberData.value.m_code, {
      m_id: credentialsForm.value.m_id.trim(),
      m_pw: credentialsForm.value.m_pw.trim()
    });
    
    // 로컬 데이터 업데이트
    memberData.value.m_id = credentialsForm.value.m_id.trim();
    memberData.value.m_pw = credentialsForm.value.m_pw.trim();
    
    isEditingCredentials.value = false;
    snackbarText.value = '로그인 정보가 저장되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    console.error('로그인 정보 저장 오류:', error);
    snackbarText.value = error.response?.data?.message || '저장에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    savingCredentials.value = false;
  }
};

// 대표자 정보 수정 시작
const startEditBossInfo = () => {
  const data = memberData?.value;
  if (!data) return;
  
  bossInfoForm.value = {
    m_boss_name: data.m_boss_name || '',
    m_boss_phone: data.m_boss_phone || ''
  };
  isEditingBossInfo.value = true;
};

// 대표자 정보 수정 취소
const cancelEditBossInfo = () => {
  isEditingBossInfo.value = false;
};

// 대표자 정보 저장
const saveBossInfo = async () => {
  if (!memberData?.value?.m_code) return;
  
  savingBossInfo.value = true;
  try {
    const updateData = {
      m_boss_name: bossInfoForm.value.m_boss_name.trim() || null,
      m_boss_phone: bossInfoForm.value.m_boss_phone.trim() || null
    };
    
    await memberApi.update(memberData.value.m_code, updateData);
    
    // 로컬 데이터 업데이트
    Object.assign(memberData.value, updateData);
    
    isEditingBossInfo.value = false;
    snackbarText.value = '대표자 정보가 저장되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    console.error('대표자 정보 저장 오류:', error);
    snackbarText.value = error.response?.data?.message || '저장에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    savingBossInfo.value = false;
  }
};

// 크롤링 데이터 연결 확인
const checkCrawlData = async (mCode: string) => {
  if (!mCode) {
    hasCrawlData.value = false;
    return;
  }
  
  try {
    const response = await crawlApi.getDetail(mCode);
    hasCrawlData.value = !!response.data?.data?.main;
  } catch {
    hasCrawlData.value = false;
  }
};

// memberData 변경 감지
watch(() => memberData?.value?.m_longterm_code, (newCode) => {
  if (newCode) {
    checkCrawlData(newCode);
  }
}, { immediate: true });

// 인증서 정보 로드
const loadCertInfo = async () => {
  if (!memberData?.value?.m_code) return;
  
  certLoading.value = true;
  try {
    const response = await certApi.getInfo(memberData.value.m_code);
    certInfo.value = response.data?.data || null;
    
    // 슈퍼관리자이고 인증서가 있으면 IP 목록도 로드
    if (isSuperAdmin.value && certInfo.value?.cic_idx) {
      loadAllowedIPs();
    }
  } catch (error: any) {
    if (error.response?.status !== 404) {
      console.error('인증서 정보 로드 오류:', error);
    }
    certInfo.value = null;
  } finally {
    certLoading.value = false;
  }
};

const parseDerPreview = (file: File) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const arrayBuffer = e.target?.result as ArrayBuffer;
      const bytes = new Uint8Array(arrayBuffer);
      let binaryString = '';
      for (let j = 0; j < bytes.length; j++) {
        binaryString += String.fromCharCode(bytes[j]);
      }

      const asn1 = forge.asn1.fromDer(binaryString);
      const certificate = forge.pki.certificateFromAsn1(asn1);

      const decodeField = (field: any): string => {
        if (!field?.value) return '';
        try {
          const fieldBytes = new Uint8Array([...field.value].map((c: string) => c.charCodeAt(0)));
          return new TextDecoder('utf-8').decode(fieldBytes);
        } catch {
          return field.value;
        }
      };

      const cnValue = decodeField(certificate.subject.getField('CN'));
      const serialNumber = decodeField(certificate.subject.getField('serialNumber'));

      let subject = cnValue;
      if (serialNumber && !cnValue.includes(serialNumber)) {
        subject = `${cnValue}(${serialNumber})`;
      }

      const validTo = certificate.validity.notAfter;
      const expireDate = `${validTo.getFullYear()}-${String(validTo.getMonth() + 1).padStart(2, '0')}-${String(validTo.getDate()).padStart(2, '0')}`;

      extractedCertInfo.value = { subject, expireDate };
    } catch (error) {
      console.error('DER 파일 파싱 오류:', error);
      extractedCertInfo.value = null;
    }
  };
  reader.readAsArrayBuffer(file);
};

// 폴더/파일 목록에서 der+key 자동 인식
const processFiles = (files: FileList | File[]) => {
  const picked = pickNpkiCertFiles(files);
  if (!picked.ok) {
    snackbarText.value = picked.message;
    snackbarColor.value = 'error';
    snackbar.value = true;
    return;
  }

  signCertFile.value = picked.der;
  signPriFile.value = picked.key;
  signCertFileName.value = picked.der.name;
  signPriFileName.value = picked.key.name;
  pickedCertFolderHint.value = picked.pairDir;
  parseDerPreview(picked.der);
};

const onCertFolderChange = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;
  processFiles(input.files);
  input.value = '';
};

// 인증서 파일 선택 (input change 이벤트)
const onCertFilesChange = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;
  
  processFiles(input.files);
  
  // input 초기화 (같은 파일 재선택 가능하도록)
  input.value = '';
};

// 인증서 업로드 모달 닫기
const closeCertUploadModal = () => {
  if (certUploading.value) return;
  showCertUploadModal.value = false;
  signCertFile.value = null;
  signPriFile.value = null;
  signCertFileName.value = '';
  signPriFileName.value = '';
  pickedCertFolderHint.value = '';
  certPassword.value = '';
  showCertPassword.value = false;
  extractedCertInfo.value = null;
  certEditMode.value = 'password';
  newCertPassword.value = '';
  showNewCertPassword.value = false;
};

// 인증서 모달 열기 — 만료된 인증서는 전체 변경 탭이 기본
const openCertModal = () => {
  certEditMode.value = certInfo.value && !isExpired.value ? 'password' : 'full';
  showCertUploadModal.value = true;
};

// 비밀번호만 변경
const updateCertPasswordOnly = async () => {
  if (!certInfo.value?.cic_idx || !newCertPassword.value.trim()) {
    return;
  }

  certPasswordUpdating.value = true;
  try {
    await certApi.updatePassword(certInfo.value.cic_idx, newCertPassword.value);
    
    closeCertUploadModal();
    
    snackbarText.value = '비밀번호가 변경되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    console.error('비밀번호 변경 오류:', error);
    snackbarText.value = error.response?.data?.message || '비밀번호 변경에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    certPasswordUpdating.value = false;
  }
};

// 인증서 업로드 (NPKI 방식)
const uploadCert = async () => {
  if (!memberData?.value?.m_code || !signCertFile.value || !signPriFile.value || !certPassword.value.trim()) {
    return;
  }

  certUploading.value = true;
  try {
    const formData = new FormData();
    formData.append('mCode', String(memberData.value.m_code));
    formData.append('signCert', signCertFile.value);  // signCert.der
    formData.append('signPri', signPriFile.value);    // signPri.key
    formData.append('password', certPassword.value);  // 인증서 비밀번호
    
    if (extractedCertInfo.value) {
      formData.append('certName', extractedCertInfo.value.subject);
      formData.append('expireDate', extractedCertInfo.value.expireDate);
    }

    await certApi.upload(formData);
    
    // 모달 닫기
    certUploading.value = false;
    showCertUploadModal.value = false;
    signCertFile.value = null;
    signPriFile.value = null;
    signCertFileName.value = '';
    signPriFileName.value = '';
    pickedCertFolderHint.value = '';
    certPassword.value = '';
    showCertPassword.value = false;
    extractedCertInfo.value = null;
    
    await loadCertInfo();
    
    snackbarText.value = '인증서가 등록되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    console.error('인증서 업로드 오류:', error);
    snackbarText.value = error.response?.data?.message || '인증서 업로드에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    certUploading.value = false;
  }
};

// 인증서 삭제 확인
const confirmDeleteCert = () => {
  showDeleteCertDialog.value = true;
};

// 인증서 삭제
const deleteCert = async () => {
  if (!certInfo.value?.cic_idx) return;

  certDeleting.value = true;
  try {
    await certApi.delete(certInfo.value.cic_idx);
    
    showDeleteCertDialog.value = false;
    certInfo.value = null;
    
    snackbarText.value = '인증서가 삭제되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    console.error('인증서 삭제 오류:', error);
    snackbarText.value = error.response?.data?.message || '인증서 삭제에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    certDeleting.value = false;
  }
};

// ========== IP 관리 함수 (슈퍼바이저 전용) ==========

const toggleIpManagement = () => {
  showIpManagement.value = !showIpManagement.value;
  if (showIpManagement.value && certInfo.value?.cic_idx) {
    loadAllowedIPs();
    loadMyIP();
  }
};

const loadAllowedIPs = async () => {
  if (!certInfo.value?.cic_idx) return;
  
  loadingIPs.value = true;
  try {
    const res = await certApi.getAllowedIPs(certInfo.value.cic_idx);
    allowedIPs.value = res.data.data || [];
  } catch (error) {
    console.error('허용 IP 목록 조회 실패:', error);
    allowedIPs.value = [];
  } finally {
    loadingIPs.value = false;
  }
};

const loadMyIP = async () => {
  try {
    const res = await certApi.getMyIP();
    myIP.value = res.data.data?.ip || '';
  } catch (error) {
    console.error('IP 조회 실패:', error);
  }
};

const openAddIpDialog = () => {
  newIP.value = { ip: '', description: '' };
  showAddIpDialog.value = true;
};

const applyMyIP = () => {
  if (myIP.value) {
    newIP.value.ip = myIP.value;
  }
};

const addAllowedIP = async () => {
  if (!newIP.value.ip || !certInfo.value?.cic_idx) return;

  addingIP.value = true;
  try {
    await certApi.addAllowedIP(certInfo.value.cic_idx, {
      ip: newIP.value.ip.trim(),
      description: newIP.value.description.trim()
    });
    showAddIpDialog.value = false;
    loadAllowedIPs();
    snackbarText.value = 'IP가 추가되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    const msg = error.response?.data?.message || 'IP 추가에 실패했습니다.';
    snackbarText.value = msg;
    snackbarColor.value = 'error';
    snackbar.value = true;
  } finally {
    addingIP.value = false;
  }
};

const deleteAllowedIP = async (ip: any) => {
  if (!confirm(`IP ${ip.ccai_ip}를 삭제하시겠습니까?`)) return;

  try {
    await certApi.deleteAllowedIP(ip.ccai_idx);
    loadAllowedIPs();
    snackbarText.value = 'IP가 삭제되었습니다.';
    snackbarColor.value = 'success';
    snackbar.value = true;
  } catch (error: any) {
    snackbarText.value = 'IP 삭제에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  }
};

const toggleAllowedIP = async (ip: any, isActive: boolean) => {
  try {
    await certApi.toggleAllowedIP(ip.ccai_idx, isActive);
    ip.ccai_is_active = isActive ? 1 : 0;
  } catch (error: any) {
    snackbarText.value = '상태 변경에 실패했습니다.';
    snackbarColor.value = 'error';
    snackbar.value = true;
  }
};

onMounted(() => {
  loadBizGubunOptions();
  loadCertInfo();
  if (memberData?.value?.m_longterm_code) {
    checkCrawlData(memberData.value.m_longterm_code);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["tab-btn", { active: mainTab.value === 'member' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (mainTab.value = 'member'))
      }, [
        _createVNode(_component_v_icon, { size: "18" }, {
          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
            _createTextVNode("mdi-domain", -1)
          ]))]),
          _: 1
        }),
        _cache[34] || (_cache[34] = _createElementVNode("span", null, "관리정보", -1))
      ], 2),
      (isAdmin.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["tab-btn", { active: mainTab.value === 'crawl', disabled: !_unref(memberData)?.m_longterm_code || !hasCrawlData.value }]),
            disabled: !_unref(memberData)?.m_longterm_code || !hasCrawlData.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (mainTab.value = 'crawl'))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode("mdi-hospital-building", -1)
              ]))]),
              _: 1
            }),
            _cache[36] || (_cache[36] = _createElementVNode("span", null, "시설정보", -1)),
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "tab-admin-badge" }, "관리자전용", -1)),
            (!_unref(memberData)?.m_longterm_code || !hasCrawlData.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "연결없음"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_window, {
        modelValue: mainTab.value,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((mainTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "member" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-information-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[41] || (_cache[41] = _createTextVNode(" 기본정보 ", -1)),
                (!isEditingBasicInfo.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "edit-btn",
                      onClick: startEditBasicInfo
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("mdi-pencil", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[40] || (_cache[40] = _createTextVNode(" 수정 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!isEditingBasicInfo.value)
                ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[42] || (_cache[42] = _createElementVNode("th", null, "시설명", -1)),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(memberData)?.m_name || '-'), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[43] || (_cache[43] = _createElementVNode("th", null, "시설코드", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_longterm_code || '-'), 1),
                        _cache[44] || (_cache[44] = _createElementVNode("th", null, "사업구분", -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_9, [
                            (_unref(memberData)?.m_biz_gubun)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(parseBizGubun(_unref(memberData).m_biz_gubun), (biz) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: biz,
                                    color: getBizGubunColor(biz),
                                    size: "small",
                                    label: "",
                                    variant: "flat",
                                    class: "mr-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(biz), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[45] || (_cache[45] = _createElementVNode("th", null, "사업자번호", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_biz_num || '-'), 1),
                        _cache[46] || (_cache[46] = _createElementVNode("th", null, "설립일", -1)),
                        _createElementVNode("td", null, _toDisplayString(formatDate(_unref(memberData)?.m_since)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[47] || (_cache[47] = _createElementVNode("th", null, "현원", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_hyunwon || 0) + "명", 1),
                        _cache[48] || (_cache[48] = _createElementVNode("th", null, "정원", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_jungwon || 0) + "명", 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[49] || (_cache[49] = _createElementVNode("th", null, "주소", -1)),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(memberData)?.m_addr || '-'), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[50] || (_cache[50] = _createElementVNode("th", null, "전화번호", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_tell || '-'), 1),
                        _cache[51] || (_cache[51] = _createElementVNode("th", null, "이메일", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_boss_email || '-'), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("table", _hoisted_12, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[52] || (_cache[52] = _createElementVNode("th", null, [
                          _createTextVNode("시설명 "),
                          _createElementVNode("span", { class: "required" }, "*")
                        ], -1)),
                        _createElementVNode("td", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((basicInfoForm.value.m_name) = $event)),
                            type: "text",
                            class: "native-input full-width",
                            placeholder: "시설명을 입력하세요"
                          }, null, 512), [
                            [_vModelText, basicInfoForm.value.m_name]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[53] || (_cache[53] = _createElementVNode("th", null, "시설코드", -1)),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((basicInfoForm.value.m_longterm_code) = $event)),
                            type: "text",
                            class: "native-input compact",
                            placeholder: "시설코드"
                          }, null, 512), [
                            [_vModelText, basicInfoForm.value.m_longterm_code]
                          ])
                        ]),
                        _cache[54] || (_cache[54] = _createElementVNode("th", null, [
                          _createTextVNode("사업구분 "),
                          _createElementVNode("span", { class: "required" }, "*")
                        ], -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizGubunOptions.value, (biz) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: biz.bg_name,
                                class: _normalizeClass(["biz-checkbox-item", { 
                        checked: basicInfoForm.value.m_biz_gubun_list.includes(biz.bg_name),
                        disabled: isBizGubunDisabled(biz.bg_exclusive_group)
                      }])
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  value: biz.bg_name,
                                  checked: basicInfoForm.value.m_biz_gubun_list.includes(biz.bg_name),
                                  disabled: isBizGubunDisabled(biz.bg_exclusive_group),
                                  onChange: ($event: any) => (toggleBizGubun(biz.bg_name, biz.bg_exclusive_group))
                                }, null, 40, _hoisted_15),
                                _createElementVNode("span", {
                                  class: "checkbox-label",
                                  style: _normalizeStyle({ 
                          '--biz-color': biz.bg_color,
                          backgroundColor: basicInfoForm.value.m_biz_gubun_list.includes(biz.bg_name) ? biz.bg_color : 'transparent',
                          color: basicInfoForm.value.m_biz_gubun_list.includes(biz.bg_name) ? 'white' : biz.bg_color,
                          borderColor: biz.bg_color,
                          opacity: isBizGubunDisabled(biz.bg_exclusive_group) ? 0.4 : 1
                        })
                                }, _toDisplayString(biz.bg_name), 5)
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[55] || (_cache[55] = _createElementVNode("th", null, "사업자번호", -1)),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((basicInfoForm.value.m_biz_num) = $event)),
                            type: "text",
                            class: "native-input compact",
                            placeholder: "000-00-00000"
                          }, null, 512), [
                            [_vModelText, basicInfoForm.value.m_biz_num]
                          ])
                        ]),
                        _cache[56] || (_cache[56] = _createElementVNode("th", null, "설립일", -1)),
                        _createElementVNode("td", null, [
                          _createVNode(YmdDateInput, {
                            modelValue: basicInfoForm.value.m_since,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((basicInfoForm.value.m_since) = $event)),
                            class: "native-input compact"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[59] || (_cache[59] = _createElementVNode("th", null, "현원", -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_16, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((basicInfoForm.value.m_hyunwon) = $event)),
                              type: "number",
                              class: "native-input compact",
                              min: "0"
                            }, null, 512), [
                              [
                                _vModelText,
                                basicInfoForm.value.m_hyunwon,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "unit" }, "명", -1))
                          ])
                        ]),
                        _cache[60] || (_cache[60] = _createElementVNode("th", null, "정원", -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((basicInfoForm.value.m_jungwon) = $event)),
                              type: "number",
                              class: "native-input compact",
                              min: "0"
                            }, null, 512), [
                              [
                                _vModelText,
                                basicInfoForm.value.m_jungwon,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "unit" }, "명", -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[61] || (_cache[61] = _createElementVNode("th", null, "주소", -1)),
                        _createElementVNode("td", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((basicInfoForm.value.m_addr) = $event)),
                            type: "text",
                            class: "native-input full-width",
                            placeholder: "주소를 입력하세요"
                          }, null, 512), [
                            [_vModelText, basicInfoForm.value.m_addr]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[62] || (_cache[62] = _createElementVNode("th", null, "전화번호", -1)),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((basicInfoForm.value.m_tell) = $event)),
                            type: "tel",
                            class: "native-input compact",
                            placeholder: "000-0000-0000"
                          }, null, 512), [
                            [_vModelText, basicInfoForm.value.m_tell]
                          ])
                        ]),
                        _cache[63] || (_cache[63] = _createElementVNode("th", null, "이메일", -1)),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((basicInfoForm.value.m_boss_email) = $event)),
                            type: "email",
                            class: "native-input compact",
                            placeholder: "email@example.com"
                          }, null, 512), [
                            [_vModelText, basicInfoForm.value.m_boss_email]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_19, [
                          _createElementVNode("button", {
                            class: "save-btn",
                            onClick: saveBasicInfo,
                            disabled: savingBasicInfo.value
                          }, [
                            (savingBasicInfo.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "14",
                                  width: "2",
                                  class: "mr-1"
                                }))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  size: "14",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                    _createTextVNode("mdi-check", -1)
                                  ]))]),
                                  _: 1
                                })),
                            _cache[65] || (_cache[65] = _createTextVNode(" 저장 ", -1))
                          ], 8, _hoisted_20),
                          _createElementVNode("button", {
                            class: "cancel-btn",
                            onClick: cancelEditBasicInfo
                          }, " 취소 ")
                        ])
                      ])
                    ])
                  ])),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                    _createTextVNode("mdi-lock-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[69] || (_cache[69] = _createTextVNode(" 로그인 정보 ", -1)),
                (!isEditingCredentials.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "edit-btn",
                      onClick: startEditCredentials
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                          _createTextVNode("mdi-pencil", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[68] || (_cache[68] = _createTextVNode(" 수정 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[76] || (_cache[76] = _createElementVNode("th", null, "아이디 (ID)", -1)),
                    _createElementVNode("td", null, [
                      (isEditingCredentials.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_23, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((credentialsForm.value.m_id) = $event)),
                                type: "text",
                                class: _normalizeClass(["native-input compact", { 'is-valid': idCheckState.value.checked && idCheckState.value.available, 'is-invalid': idCheckState.value.checked && !idCheckState.value.available }]),
                                placeholder: "아이디",
                                onInput: onIdChange
                              }, null, 34), [
                                [_vModelText, credentialsForm.value.m_id]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "check-id-btn",
                                onClick: checkIdDuplicate,
                                disabled: !credentialsForm.value.m_id.trim() || idCheckLoading.value || !isIdChanged.value
                              }, [
                                (idCheckLoading.value)
                                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                      key: 0,
                                      indeterminate: "",
                                      size: "12",
                                      width: "2"
                                    }))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("중복확인")
                                    ], 64))
                              ], 8, _hoisted_24)
                            ]),
                            (idCheckState.value.checked && idCheckState.value.available)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                  _createVNode(_component_v_icon, { size: "12" }, {
                                    default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                      _createTextVNode("mdi-check-circle", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[71] || (_cache[71] = _createTextVNode(" 사용 가능 ", -1))
                                ]))
                              : (idCheckState.value.checked && !idCheckState.value.available)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _createVNode(_component_v_icon, { size: "12" }, {
                                      default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                        _createTextVNode("mdi-alert-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[73] || (_cache[73] = _createTextVNode(" 사용 불가 ", -1))
                                  ]))
                                : (isIdChanged.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                      _createVNode(_component_v_icon, { size: "12" }, {
                                        default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                          _createTextVNode("mdi-alert", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[75] || (_cache[75] = _createTextVNode(" 중복확인 필요 ", -1))
                                    ]))
                                  : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(memberData)?.m_id || '-'), 1)
                          ], 64))
                    ]),
                    _cache[77] || (_cache[77] = _createElementVNode("th", null, "비밀번호 (PW)", -1)),
                    _createElementVNode("td", null, [
                      (isEditingCredentials.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((credentialsForm.value.m_pw) = $event)),
                            type: "text",
                            class: "native-input compact",
                            placeholder: "비밀번호"
                          }, null, 512)), [
                            [_vModelText, credentialsForm.value.m_pw]
                          ])
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(showPassword.value ? _unref(memberData)?.m_pw : maskedPassword.value), 1),
                            _createElementVNode("button", {
                              class: "toggle-pw-btn",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (showPassword.value = !showPassword.value)),
                              title: showPassword.value ? '비밀번호 숨기기' : '비밀번호 보기'
                            }, [
                              _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(showPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_30)
                          ]))
                    ])
                  ]),
                  (isEditingCredentials.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("button", {
                            class: "save-btn",
                            onClick: saveCredentials,
                            disabled: savingCredentials.value || (isIdChanged.value && (!idCheckState.value.checked || !idCheckState.value.available))
                          }, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                _createTextVNode("mdi-check", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[79] || (_cache[79] = _createTextVNode(" 저장 ", -1))
                          ], 8, _hoisted_33),
                          _createElementVNode("button", {
                            class: "cancel-btn",
                            onClick: cancelEditCredentials
                          }, " 취소 ")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                    _createTextVNode("mdi-account-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[83] || (_cache[83] = _createTextVNode(" 대표자 정보 ", -1)),
                (!isEditingBossInfo.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "edit-btn",
                      onClick: startEditBossInfo
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                          _createTextVNode("mdi-pencil", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[82] || (_cache[82] = _createTextVNode(" 수정 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!isEditingBossInfo.value)
                ? (_openBlock(), _createElementBlock("table", _hoisted_35, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[84] || (_cache[84] = _createElementVNode("th", null, "대표자명", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_boss_name || '-'), 1),
                        _cache[85] || (_cache[85] = _createElementVNode("th", null, "대표 연락처", -1)),
                        _createElementVNode("td", null, _toDisplayString(_unref(memberData)?.m_boss_phone || '-'), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("table", _hoisted_36, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[86] || (_cache[86] = _createElementVNode("th", null, "대표자명", -1)),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((bossInfoForm.value.m_boss_name) = $event)),
                            type: "text",
                            class: "native-input compact",
                            placeholder: "대표자명"
                          }, null, 512), [
                            [_vModelText, bossInfoForm.value.m_boss_name]
                          ])
                        ]),
                        _cache[87] || (_cache[87] = _createElementVNode("th", null, "대표 연락처", -1)),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((bossInfoForm.value.m_boss_phone) = $event)),
                            type: "tel",
                            class: "native-input compact",
                            placeholder: "000-0000-0000"
                          }, null, 512), [
                            [_vModelText, bossInfoForm.value.m_boss_phone]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("button", {
                            class: "save-btn",
                            onClick: saveBossInfo,
                            disabled: savingBossInfo.value
                          }, [
                            (savingBossInfo.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "14",
                                  width: "2",
                                  class: "mr-1"
                                }))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  size: "14",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                    _createTextVNode("mdi-check", -1)
                                  ]))]),
                                  _: 1
                                })),
                            _cache[89] || (_cache[89] = _createTextVNode(" 저장 ", -1))
                          ], 8, _hoisted_38),
                          _createElementVNode("button", {
                            class: "cancel-btn",
                            onClick: cancelEditBossInfo
                          }, " 취소 ")
                        ])
                      ])
                    ])
                  ])),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                    _createTextVNode("mdi-account-tie-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[91] || (_cache[91] = _createTextVNode(" 담당 권한 ", -1))
              ]),
              _createElementVNode("table", _hoisted_40, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[92] || (_cache[92] = _createElementVNode("th", null, "임금담당", -1)),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(memberData)?.wage_assignee_names || '-'), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[93] || (_cache[93] = _createElementVNode("th", null, "회계담당", -1)),
                    _createElementVNode("td", _hoisted_42, _toDisplayString(_unref(memberData)?.account_assignee_names || '-'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                    _createTextVNode("mdi-clock-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[95] || (_cache[95] = _createTextVNode(" 등록/수정 이력 ", -1))
              ]),
              _createElementVNode("table", _hoisted_44, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[96] || (_cache[96] = _createElementVNode("th", null, "등록일", -1)),
                    _createElementVNode("td", null, _toDisplayString(formatDateTime(_unref(memberData)?.m_wdate)), 1),
                    _cache[97] || (_cache[97] = _createElementVNode("th", null, "최근 수정일", -1)),
                    _createElementVNode("td", null, _toDisplayString(formatDateTime(_unref(memberData)?.m_rdate)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                    _createTextVNode("mdi-certificate", -1)
                  ]))]),
                  _: 1
                }),
                _cache[101] || (_cache[101] = _createTextVNode(" 공동인증서 ", -1)),
                (certInfo.value && !certLoading.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "edit-btn",
                      onClick: openCertModal
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                          _createTextVNode("mdi-pencil", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[100] || (_cache[100] = _createTextVNode(" 수정 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_46, [
                (certLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        size: "20",
                        width: "2"
                      }),
                      _cache[102] || (_cache[102] = _createElementVNode("span", null, "인증서 정보 확인 중...", -1))
                    ]))
                  : (certInfo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("table", _hoisted_49, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _cache[103] || (_cache[103] = _createElementVNode("th", null, "발급자", -1)),
                              _createElementVNode("td", null, _toDisplayString(certInfo.value.cic_cert_name || '-'), 1),
                              _cache[104] || (_cache[104] = _createElementVNode("th", null, "만료일", -1)),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'cert-date-alert': isExpired.value || isExpiringSoon.value })
                                }, [
                                  _createTextVNode(_toDisplayString(formatDate(certInfo.value.cic_expire_date)) + " ", 1),
                                  (isExpired.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, "만료되었습니다"))
                                    : (isExpiringSoon.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, "(만료 임박)"))
                                      : _createCommentVNode("", true)
                                ], 2)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _cache[105] || (_cache[105] = _createElementVNode("th", null, "등록일", -1)),
                              _createElementVNode("td", null, _toDisplayString(formatDateTime(certInfo.value.cic_wdate)), 1),
                              _cache[106] || (_cache[106] = _createElementVNode("th", null, "마지막 사용", -1)),
                              _createElementVNode("td", null, _toDisplayString(certInfo.value.cic_last_used ? formatDateTime(certInfo.value.cic_last_used) : '사용 기록 없음'), 1)
                            ])
                          ])
                        ]),
                        (isSuperAdmin.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("button", {
                                class: "ip-toggle-btn",
                                onClick: toggleIpManagement
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(showIpManagement.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                  ]),
                                  _: 1
                                }),
                                _cache[107] || (_cache[107] = _createTextVNode(" 접근 허용 IP 관리 ", -1)),
                                _createElementVNode("span", _hoisted_53, "(" + _toDisplayString(allowedIPs.value.length) + "개)", 1)
                              ]),
                              (showIpManagement.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _cache[108] || (_cache[108] = _createElementVNode("span", { class: "my-ip-label" }, "현재 IP:", -1)),
                                        _createElementVNode("span", _hoisted_57, _toDisplayString(myIP.value || '조회중...'), 1)
                                      ]),
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        variant: "flat",
                                        class: "btn-register",
                                        onClick: openAddIpDialog
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "16",
                                            class: "mr-1"
                                          }, {
                                            default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                              _createTextVNode("mdi-plus", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[110] || (_cache[110] = _createTextVNode(" IP 추가 ", -1))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    (loadingIPs.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                          _createVNode(_component_v_progress_circular, {
                                            indeterminate: "",
                                            size: "24"
                                          })
                                        ]))
                                      : (allowedIPs.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, " 등록된 허용 IP가 없습니다. "))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedIPs.value, (ip) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: ip.ccai_idx,
                                                class: _normalizeClass(["ip-item", { inactive: !ip.ccai_is_active }])
                                              }, [
                                                _createElementVNode("div", _hoisted_61, [
                                                  _createElementVNode("span", _hoisted_62, _toDisplayString(ip.ccai_ip), 1),
                                                  (ip.ccai_description)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(ip.ccai_description), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_64, [
                                                  _createVNode(_component_v_switch, {
                                                    "model-value": !!ip.ccai_is_active,
                                                    "hide-details": "",
                                                    density: "compact",
                                                    color: "primary",
                                                    "onUpdate:modelValue": ($event: any) => (toggleAllowedIP(ip, $event ?? false))
                                                  }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                  _createVNode(_component_v_btn, {
                                                    icon: "",
                                                    variant: "text",
                                                    size: "x-small",
                                                    color: "error",
                                                    onClick: ($event: any) => (deleteAllowedIP(ip))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { size: "16" }, {
                                                        default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                                                          _createTextVNode("mdi-delete", -1)
                                                        ]))]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["onClick"])
                                                ])
                                              ], 2))
                                            }), 128))
                                          ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createVNode(_component_v_icon, {
                            size: "40",
                            color: "grey-lighten-1"
                          }, {
                            default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                              _createTextVNode("mdi-certificate-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[115] || (_cache[115] = _createElementVNode("p", { class: "cert-empty-text" }, "등록된 공동인증서가 없습니다", -1)),
                        _cache[116] || (_cache[116] = _createElementVNode("p", { class: "cert-empty-hint" }, "공동인증서를 등록하면 자동가져오기 기능을 이용할 수 있습니다", -1)),
                        _createElementVNode("button", {
                          class: "cert-upload-btn",
                          onClick: openCertModal
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[113] || (_cache[113] = [
                              _createTextVNode("mdi-upload", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[114] || (_cache[114] = _createTextVNode(" 인증서 등록 ", -1))
                        ])
                      ]))
              ]),
              _createVNode(_component_v_dialog, {
                modelValue: showAddIpDialog.value,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showAddIpDialog).value = $event)),
                "max-width": "400"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "ip-dialog-title" }, {
                        default: _withCtx(() => [
                          _cache[118] || (_cache[118] = _createTextVNode(" IP 추가 ", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ip-dialog-close",
                            "aria-label": "닫기",
                            disabled: addingIP.value,
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (showAddIpDialog.value = false))
                          }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => [...(_cache[117] || (_cache[117] = [
                                _createTextVNode("mdi-close", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_67)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_v_text_field, {
                              modelValue: newIP.value.ip,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newIP.value.ip) = $event)),
                              label: "IP 주소",
                              placeholder: "예: 123.456.789.0",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_btn, {
                              variant: "outlined",
                              size: "small",
                              class: "apply-my-ip-btn",
                              onClick: applyMyIP,
                              disabled: !myIP.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "16",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[119] || (_cache[119] = [
                                    _createTextVNode("mdi-crosshairs-gps", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[120] || (_cache[120] = _createTextVNode(" 현재IP ", -1))
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _createVNode(_component_v_text_field, {
                            modelValue: newIP.value.description,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newIP.value.description) = $event)),
                            label: "설명 (선택)",
                            placeholder: "예: 본사 PC, 김대리 노트북",
                            variant: "outlined",
                            density: "compact",
                            class: "mt-3"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            class: "btn-cancel",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (showAddIpDialog.value = false))
                          }, {
                            default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                              _createTextVNode("취소", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            class: "btn-save",
                            onClick: addAllowedIP,
                            loading: addingIP.value
                          }, {
                            default: _withCtx(() => [...(_cache[122] || (_cache[122] = [
                              _createTextVNode("추가", -1)
                            ]))]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_dialog, {
                modelValue: showCertUploadModal.value,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((showCertUploadModal).value = $event)),
                "max-width": "600",
                persistent: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("h3", null, _toDisplayString(certInfo.value ? '공동인증서 관리' : '공동인증서 등록'), 1),
                      _createElementVNode("button", {
                        class: "close-btn",
                        onClick: closeCertUploadModal
                      }, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[123] || (_cache[123] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      (certInfo.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _createElementVNode("button", {
                              class: _normalizeClass(['mode-tab', { active: certEditMode.value === 'password' }]),
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (certEditMode.value = 'password'))
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[124] || (_cache[124] = [
                                  _createTextVNode("mdi-key", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[125] || (_cache[125] = _createTextVNode(" 비밀번호만 변경 ", -1))
                            ], 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(['mode-tab', { active: certEditMode.value === 'full' }]),
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (certEditMode.value = 'full'))
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                  _createTextVNode("mdi-certificate", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[127] || (_cache[127] = _createTextVNode(" 인증서 전체 변경 ", -1))
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      (certInfo.value && certEditMode.value === 'password')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _cache[128] || (_cache[128] = _createElementVNode("div", { class: "info-label" }, "현재 등록된 인증서", -1)),
                              _createElementVNode("div", _hoisted_75, _toDisplayString(certInfo.value.cic_cert_name || '알 수 없음'), 1),
                              _createElementVNode("div", _hoisted_76, "만료일: " + _toDisplayString(formatDate(certInfo.value.cic_expire_date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _cache[131] || (_cache[131] = _createElementVNode("label", null, [
                                _createTextVNode("새 비밀번호 "),
                                _createElementVNode("span", { class: "required" }, "*")
                              ], -1)),
                              _createElementVNode("div", _hoisted_78, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((newCertPassword).value = $event)),
                                  type: showNewCertPassword.value ? 'text' : 'password',
                                  class: "native-input full-width",
                                  placeholder: "새 인증서 비밀번호를 입력하세요"
                                }, null, 8, _hoisted_79), [
                                  [_vModelDynamic, newCertPassword.value]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "toggle-password-btn",
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (showNewCertPassword.value = !showNewCertPassword.value))
                                }, [
                                  _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(showNewCertPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_80, [
                                _createVNode(_component_v_icon, {
                                  size: "12",
                                  color: "warning",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                                    _createTextVNode("mdi-alert", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[130] || (_cache[130] = _createTextVNode(" 저장 시 비밀번호가 이 인증서와 일치하는지 자동으로 확인됩니다. ", -1))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!certInfo.value || certEditMode.value === 'full')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createVNode(_component_v_icon, {
                                  size: "20",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [...(_cache[132] || (_cache[132] = [
                                    _createTextVNode("mdi-information", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[133] || (_cache[133] = _createElementVNode("strong", null, "인증서 폴더 한 번에 올리기", -1))
                              ]),
                              _createElementVNode("div", _hoisted_83, [
                                _cache[139] || (_cache[139] = _createElementVNode("div", { class: "guide-step" }, [
                                  _createElementVNode("div", { class: "step-number" }, "1"),
                                  _createElementVNode("div", { class: "step-content" }, [
                                    _createElementVNode("span", { class: "step-title" }, "아래 「인증서 폴더 선택」 버튼 클릭"),
                                    _createElementVNode("span", { class: "step-desc" }, "폴더를 고르는 창이 열립니다.")
                                  ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_84, [
                                  _cache[138] || (_cache[138] = _createElementVNode("div", { class: "step-number" }, "2", -1)),
                                  _createElementVNode("div", _hoisted_85, [
                                    _cache[136] || (_cache[136] = _createElementVNode("span", { class: "step-title" }, "열린 창 주소창에 경로 붙여넣기", -1)),
                                    _cache[137] || (_cache[137] = _createElementVNode("span", { class: "step-desc" }, "경로를 복사한 뒤 창 위쪽 주소창에 붙여넣고 Enter", -1)),
                                    _createElementVNode("div", _hoisted_86, [
                                      _cache[135] || (_cache[135] = _createElementVNode("code", null, "%USERPROFILE%\\AppData\\LocalLow\\NPKI", -1)),
                                      _createElementVNode("button", {
                                        class: "copy-path-btn",
                                        onClick: copyNpkiPath,
                                        type: "button"
                                      }, [
                                        _createVNode(_component_v_icon, { size: "14" }, {
                                          default: _withCtx(() => [...(_cache[134] || (_cache[134] = [
                                            _createTextVNode("mdi-content-copy", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ])
                                ]),
                                _cache[140] || (_cache[140] = _createElementVNode("div", { class: "guide-step" }, [
                                  _createElementVNode("div", { class: "step-number" }, "3"),
                                  _createElementVNode("div", { class: "step-content" }, [
                                    _createElementVNode("span", { class: "step-title" }, "내 인증서 폴더까지 이동"),
                                    _createElementVNode("span", { class: "step-desc" }, [
                                      _createTextVNode(" 인증기관 폴더(예: yessign, SignKorea) → "),
                                      _createElementVNode("b", null, "USER"),
                                      _createTextVNode(" → 본인 인증서 폴더(cn=… 형태)를 선택하고 「폴더 선택」 확인 ")
                                    ]),
                                    _createElementVNode("span", { class: "step-desc step-desc--tip" }, " 인증서가 여러 개면 USER를 통째로 고르지 말고, 사용할 인증서 폴더 하나만 선택하세요. ")
                                  ])
                                ], -1)),
                                _cache[141] || (_cache[141] = _createElementVNode("div", { class: "guide-step" }, [
                                  _createElementVNode("div", { class: "step-number" }, "4"),
                                  _createElementVNode("div", { class: "step-content" }, [
                                    _createElementVNode("span", { class: "step-title" }, "자동 인식 확인"),
                                    _createElementVNode("span", { class: "step-desc" }, [
                                      _createElementVNode("span", { class: "file-badge cert" }, "signCert.der"),
                                      _createTextVNode(" / "),
                                      _createElementVNode("span", { class: "file-badge key" }, "signPri.key"),
                                      _createTextVNode(" 가 자동으로 채워집니다. 그 다음 비밀번호만 입력하면 됩니다. ")
                                    ]),
                                    _createElementVNode("span", { class: "step-desc step-desc--tip" }, " USB·다른 PC에 복사해 둔 인증서도 같은 방법으로 폴더만 선택하면 됩니다. ")
                                  ])
                                ], -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _cache[155] || (_cache[155] = _createElementVNode("label", null, [
                                _createTextVNode("인증서 파일 "),
                                _createElementVNode("span", { class: "required" }, "*")
                              ], -1)),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "cert-folder-pick-btn",
                                  onClick: triggerCertFolderInput
                                }, [
                                  _createVNode(_component_v_icon, {
                                    size: "18",
                                    class: "mr-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[142] || (_cache[142] = [
                                      _createTextVNode("mdi-folder-open", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[143] || (_cache[143] = _createTextVNode(" 인증서 폴더 선택 ", -1))
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "cert-files-pick-btn",
                                  onClick: triggerCertFilesInput
                                }, [
                                  _createVNode(_component_v_icon, {
                                    size: "16",
                                    class: "mr-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                                      _createTextVNode("mdi-file-multiple-outline", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[145] || (_cache[145] = _createTextVNode(" 파일 2개 직접 선택 ", -1))
                                ])
                              ]),
                              _createElementVNode("input", {
                                type: "file",
                                ref_key: "certFolderInputRef",
                                ref: certFolderInputRef,
                                style: {"display":"none"},
                                onChange: onCertFolderChange
                              }, null, 544),
                              _createElementVNode("div", {
                                class: _normalizeClass(["file-drop-zone", { 'drag-over': isDragOver.value, 'has-files': signCertFile.value && signPriFile.value }]),
                                onDragover: _withModifiers(onDragOver, ["prevent"]),
                                onDragleave: _withModifiers(onDragLeave, ["prevent"]),
                                onDrop: _withModifiers(onDrop, ["prevent"])
                              }, [
                                _createElementVNode("input", {
                                  type: "file",
                                  ref_key: "certFilesInputRef",
                                  ref: certFilesInputRef,
                                  accept: ".der,.key",
                                  multiple: "",
                                  onChange: onCertFilesChange,
                                  style: {"display":"none"}
                                }, null, 544),
                                (!signCertFile.value && !signPriFile.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                      _createVNode(_component_v_icon, {
                                        size: "32",
                                        color: isDragOver.value ? 'primary' : 'grey-lighten-1'
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(isDragOver.value ? 'mdi-file-download' : 'mdi-folder-upload-outline'), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"]),
                                      _cache[146] || (_cache[146] = _createElementVNode("span", { class: "drop-text" }, " 위 버튼으로 폴더를 선택하거나, 파일을 여기에 드래그하세요 ", -1)),
                                      _cache[147] || (_cache[147] = _createElementVNode("span", { class: "drop-hint" }, "권장: 인증서 폴더 통째 선택 → der/key 자동 인식", -1))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["file-item", { 'has-file': signCertFile.value }])
                                      }, [
                                        (signCertFile.value)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              size: "16",
                                              color: "success"
                                            }, {
                                              default: _withCtx(() => [...(_cache[148] || (_cache[148] = [
                                                _createTextVNode("mdi-check-circle", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "16",
                                              color: "grey-lighten-1"
                                            }, {
                                              default: _withCtx(() => [...(_cache[149] || (_cache[149] = [
                                                _createTextVNode("mdi-close-circle", -1)
                                              ]))]),
                                              _: 1
                                            })),
                                        _cache[150] || (_cache[150] = _createElementVNode("span", { class: "file-badge cert" }, "signCert.der", -1)),
                                        _createElementVNode("span", _hoisted_91, _toDisplayString(signCertFile.value ? signCertFileName.value : '선택 안됨'), 1)
                                      ], 2),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["file-item", { 'has-file': signPriFile.value }])
                                      }, [
                                        (signPriFile.value)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              size: "16",
                                              color: "success"
                                            }, {
                                              default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                                                _createTextVNode("mdi-check-circle", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "16",
                                              color: "grey-lighten-1"
                                            }, {
                                              default: _withCtx(() => [...(_cache[152] || (_cache[152] = [
                                                _createTextVNode("mdi-close-circle", -1)
                                              ]))]),
                                              _: 1
                                            })),
                                        _cache[153] || (_cache[153] = _createElementVNode("span", { class: "file-badge key" }, "signPri.key", -1)),
                                        _createElementVNode("span", _hoisted_92, _toDisplayString(signPriFile.value ? signPriFileName.value : '선택 안됨'), 1)
                                      ], 2),
                                      (pickedCertFolderHint.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, "폴더: " + _toDisplayString(pickedCertFolderHint.value), 1))
                                        : _createCommentVNode("", true),
                                      _cache[154] || (_cache[154] = _createElementVNode("span", { class: "change-hint" }, "위에서 다시 선택하면 변경됩니다", -1))
                                    ]))
                              ], 34)
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _cache[158] || (_cache[158] = _createElementVNode("label", null, [
                                _createTextVNode("인증서 비밀번호 "),
                                _createElementVNode("span", { class: "required" }, "*")
                              ], -1)),
                              _createElementVNode("div", _hoisted_95, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((certPassword).value = $event)),
                                  type: showCertPassword.value ? 'text' : 'password',
                                  class: "native-input full-width",
                                  placeholder: "인증서 비밀번호를 입력하세요"
                                }, null, 8, _hoisted_96), [
                                  [_vModelDynamic, certPassword.value]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "toggle-password-btn",
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (showCertPassword.value = !showCertPassword.value)),
                                  title: showCertPassword.value ? '비밀번호 숨기기' : '비밀번호 보기'
                                }, [
                                  _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(showCertPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_97)
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _createVNode(_component_v_icon, {
                                  size: "12",
                                  color: "warning",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[156] || (_cache[156] = [
                                    _createTextVNode("mdi-alert", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[157] || (_cache[157] = _createTextVNode(" 등록 시 비밀번호가 이 인증서와 일치하는지 자동으로 확인됩니다. ", -1))
                              ])
                            ]),
                            (extractedCertInfo.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                  _createElementVNode("div", _hoisted_100, [
                                    _createVNode(_component_v_icon, {
                                      size: "16",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => [...(_cache[159] || (_cache[159] = [
                                        _createTextVNode("mdi-certificate", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[160] || (_cache[160] = _createElementVNode("span", null, "인증서 정보", -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_101, [
                                    _cache[161] || (_cache[161] = _createElementVNode("span", { class: "cert-info-label" }, "발급자", -1)),
                                    _createElementVNode("span", _hoisted_102, _toDisplayString(extractedCertInfo.value.subject), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_103, [
                                    _cache[162] || (_cache[162] = _createElementVNode("span", { class: "cert-info-label" }, "만료일", -1)),
                                    _createElementVNode("span", _hoisted_104, _toDisplayString(extractedCertInfo.value.expireDate), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_105, [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                color: "warning"
                              }, {
                                default: _withCtx(() => [...(_cache[163] || (_cache[163] = [
                                  _createTextVNode("mdi-shield-lock", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[164] || (_cache[164] = _createElementVNode("span", null, "업로드된 인증서는 AES-256으로 암호화되어 안전하게 저장됩니다.", -1))
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      (certInfo.value && certEditMode.value === 'full')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "delete-btn",
                            onClick: confirmDeleteCert,
                            disabled: certUploading.value || certPasswordUpdating.value
                          }, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[165] || (_cache[165] = [
                                _createTextVNode("mdi-delete", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[166] || (_cache[166] = _createTextVNode(" 삭제 ", -1))
                          ], 8, _hoisted_107))
                        : _createCommentVNode("", true),
                      _cache[169] || (_cache[169] = _createElementVNode("div", { class: "footer-spacer" }, null, -1)),
                      _createElementVNode("button", {
                        class: "cancel-btn",
                        onClick: closeCertUploadModal,
                        disabled: certUploading.value || certPasswordUpdating.value
                      }, " 취소 ", 8, _hoisted_108),
                      (certInfo.value && certEditMode.value === 'password')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "save-btn",
                            onClick: updateCertPasswordOnly,
                            disabled: !newCertPassword.value.trim() || certPasswordUpdating.value
                          }, [
                            (certPasswordUpdating.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "14",
                                  width: "2",
                                  class: "mr-1"
                                }))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  size: "14",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[167] || (_cache[167] = [
                                    _createTextVNode("mdi-content-save", -1)
                                  ]))]),
                                  _: 1
                                })),
                            _createTextVNode(" " + _toDisplayString(certPasswordUpdating.value ? '저장 중...' : '비밀번호 변경'), 1)
                          ], 8, _hoisted_109))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "save-btn",
                            onClick: uploadCert,
                            disabled: !canUploadCert.value || certUploading.value
                          }, [
                            (certUploading.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "14",
                                  width: "2",
                                  class: "mr-1"
                                }))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  size: "14",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[168] || (_cache[168] = [
                                    _createTextVNode("mdi-upload", -1)
                                  ]))]),
                                  _: 1
                                })),
                            _createTextVNode(" " + _toDisplayString(certUploading.value ? '업로드 중...' : (certInfo.value ? '인증서 변경' : '등록')), 1)
                          ], 8, _hoisted_110))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_dialog, {
                modelValue: showDeleteCertDialog.value,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((showDeleteCertDialog).value = $event)),
                "max-width": "400"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dialog-x-close",
                      "aria-label": "닫기",
                      disabled: certDeleting.value,
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (showDeleteCertDialog.value = false))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[170] || (_cache[170] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_112),
                    _createElementVNode("div", _hoisted_113, [
                      _createVNode(_component_v_icon, {
                        size: "48",
                        color: "error"
                      }, {
                        default: _withCtx(() => [...(_cache[171] || (_cache[171] = [
                          _createTextVNode("mdi-alert-circle", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[173] || (_cache[173] = _createElementVNode("h3", null, "인증서 삭제", -1)),
                    _cache[174] || (_cache[174] = _createElementVNode("p", null, [
                      _createTextVNode("등록된 공동인증서를 삭제하시겠습니까?"),
                      _createElementVNode("br"),
                      _createTextVNode("삭제 후에는 복구할 수 없습니다.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("button", {
                        class: "cancel-btn",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (showDeleteCertDialog.value = false))
                      }, "취소"),
                      _createElementVNode("button", {
                        class: "delete-btn",
                        onClick: deleteCert,
                        disabled: certDeleting.value
                      }, [
                        (certDeleting.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              size: "14",
                              width: "2",
                              class: "mr-1"
                            }))
                          : _createCommentVNode("", true),
                        _cache[172] || (_cache[172] = _createTextVNode(" 삭제 ", -1))
                      ], 8, _hoisted_115)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(HopeCertSection, {
                "m-code": _unref(memberData)?.m_code
              }, null, 8, ["m-code"])
            ]),
            _: 1
          }),
          (isAdmin.value)
            ? (_openBlock(), _createBlock(_component_v_window_item, {
                key: 0,
                value: "crawl"
              }, {
                default: _withCtx(() => [
                  (mainTab.value === 'crawl' && _unref(memberData)?.m_longterm_code)
                    ? (_openBlock(), _createBlock(CrawlDetailContent, {
                        key: 0,
                        "cc-number": _unref(memberData).m_longterm_code,
                        embedded: true
                      }, null, 8, ["cc-number"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((snackbar).value = $event)),
      timeout: 2000,
      color: snackbarColor.value,
      location: "bottom"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbarText.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})